import { css } from 'emotion'

export const marginSmallStyles = css`
  margin: 8px;
`
